import {
  getSubscriptionById,
  getUserSubscriptions
} from "./chunk-G6HFKZYY.mjs";
import {
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/hooks/wbk/subscriptions/user.ts
import { useQuery } from "@tanstack/react-query";
var useGetSubscriptionById = (props) => {
  return useQuery({
    queryKey: ["getSubscriptionById", props],
    queryFn: () => getSubscriptionById(props)
  });
};
var useGetUserSubscriptions = (props, options) => {
  return useQuery(__spreadValues({
    queryKey: ["getUserSubscriptions", props],
    queryFn: () => getUserSubscriptions(props),
    staleTime: Infinity
  }, options));
};

export {
  useGetSubscriptionById,
  useGetUserSubscriptions
};
//# sourceMappingURL=chunk-LU5JBC35.mjs.map